<template>
  <modal class="message-modal" title="标题">
    弹框文本
    <vs-button @click="$modal('example2')">二级弹框</vs-button>
  </modal>
</template>
<script>
export default {
  inheritAttrs: false,
}
</script>